import React, { useState, useEffect } from "react";
import { Form, Input, Button, notification } from "antd";
import ServiceApi from "../../services/ServiceApi";
import axios from "axios";
import Cookies from "js-cookie";
import QRCode from "react-qr-code";
import NumericInput from "../../components/InputNumber"

const ChangePassWord = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [secretKey, setsecretKey] = useState("");
  const [value, setValue] = useState(0);

  const [form] = Form.useForm();
  const handleSubmit = (value) => {
    setErrorMessage("");
    setIsLoading(true);
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}CheckSecretekey`,
      method: "POST",
      data: {
        UserName: Cookies.get("username"),
        UserAuth: "maxi_wf_test",
        TokenAuth: "maxi@072020",
        VerifyCode: value.VerifyCode
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          if (res.result.description === "True") {
            Cookies.set("authenCheck", res.result.description, { expires: 1 });
            notification.success({
              message: "Verify Code Success",
              description: "Verify Code Success",
            });
            setTimeout(() => {
              window.location.assign(ServiceApi.absoluteUrl("/SelectModules"));
            }, 2000);
          }
          else {
            Cookies.remove("authenCheck");
            notification.error({
              message: "Verify Code Error",
              description: "Verify Code Error",
            });
            setIsLoading(false);
          }

        } else {
          Cookies.remove("authenCheck");
          notification.error({
            message: "Verify Code Error",
            description: "Verify Code Error",
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        Cookies.remove("authenCheck");
        notification.error({
          message: "Verify Code Error",
          description: "Verify Code Error",
        });
        setIsLoading(false);

      });
  };

  const LoadQRCode = async () => {
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}GenerateSecretekey`,
      method: "POST",
      data: {
        UserName: Cookies.get("username"),
        UserAuth: "maxi_wf_test",
        TokenAuth: "maxi@072020",
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          setsecretKey(res.data[0].secret_key);
        } else {
          setErrorMessage(res.result.showText);
        }
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setIsLoading(false);
      });

  }


  useEffect(() => {
    LoadQRCode();
  }, []);


  return (
    <div className="container body-content bbtec-theme">
      <div className="background-100"></div>

      <div className="box-container" style={{ height: "unset" }}>
        <div>
          <select defaultValue="EN" className="form-control chang-lgg">
            <option value="EN">EN</option>
            <option value="TH">TH</option>
          </select>
        </div>
        <div className="row">
          <div
            className="col-6 offset-md-1 mt-form-log"
            style={{ marginTop: 50 }}
          >
            <div>
              <img src={ServiceApi.absoluteUrl("/img/Group_278.png")} alt="" />
            </div>
            <div
              className="font-mont font24"
              // id="tabs-forgetpwd"

              style={{ color: "#5C72F7", marginTop: 10, whiteSpace: "nowrap" }}
            >
              Setup 2-Factor Authentication
            </div>
            <div
              className="font-mont font14"
              style={{ color: "#999999", marginTop: 5, whiteSpace: "nowrap" }}
            >
              Scan the QR Code on your authenticator app
            </div>
            <div className="row" style={{ margin: "0px -15px", marginTop: 10, textAlign: "center" }}>
              <div className="ant-col ant-col-xs-24 ant-col-xl-16">
                <div className="row">

                  {localStorage.getItem("status_2fa") === "0" ?
                    <div style={{ background: 'white', padding: '16px', marginLeft: "6%" }}>
                      <div className="authenTwoFA p-3">
                        <QRCode value={secretKey} />
                      </div>
                    </div>
                    : null}

                </div>
                <Form
                  onFinish={handleSubmit}
                  form={form}
                  layout="vertical"
                  hideRequiredMark="true"
                >
                  <div className="row">
                    <div className="col mt-2">
                      <Form.Item
                        name="VerifyCode"
                        label="Verification Code"
                        rules={[
                          {
                            required: true,
                            message: "Verification Code is required",
                          },
                        ]}
                        className="for-got-password font16"
                      >
                        <Input
                          // suffix={<UserOutlined />}
                          className="font-mont-r"
                          type="text"
                          size="large"
                          // pattern="[+-]?\d+(?:[.,]\d+)?"
                          placeholder="Verification Code"
                        />
                        {/* <NumericInput/> */}
                      </Form.Item>
                    </div>
                  </div>

                  <div className="row justify-content-md-center">
                    <div className="col-auto">
                      <Form.Item>
                        <Button
                          loading={isLoading}
                          size="small"
                          className="btn-warning"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 30px",
                          }}
                          onClick={() => form.submit()}
                        >
                          Confirm
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </Form>

                <div className="row">
                  <div
                    className="f-mon alarm-login"
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginTop: "10px",
                      padding: "15px",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-5 d-flex flex-row-reverse"
            style={{ paddingRight: "0px", alignItems: "flex-end" }}
          >
            <div className="d-flex flex-row-reverse" align="right">
              <div
                className="login-image"
                style={{ marginBottom: "-1px" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassWord;
